import {_addCsrfToken, notyf} from "../../app/helpers";
import { MaskInput } from "maska";
import { Modal } from 'bootstrap';
import * as FilePond from 'filepond';
import ua from 'filepond/locale/uk-ua';
import ru from 'filepond/locale/ru-ru';
import FilePondPluginFileEncode from 'filepond-plugin-file-encode';
import Cropper from 'cropperjs';
import Choices from "choices.js";

function initializeChoices() {
  const selects = document.querySelectorAll('.js--choices');
  window.choicesSelects = window.choicesSelects || [];

  selects.forEach((select) => {
    window.choicesSelects.push(new Choices(select, {
      removeItemButton: false,
      classNames: {
        containerInner: 'select__choices_inner',
        containerOuter: 'choices form-control',
      },
      allowHTML: true,
      searchResultLimit: 100,
      itemSelectText: "",
      noResultsText: 'Нічого не знайдено',
      searchFields: ['label'],
      fuseOptions: {
        threshold: 0,
      },
    }));
  });
}


const phonePatternEl = document.querySelector(".js--pattern-phone");
const jobPatternEl = document.querySelector(".js--pattern-job");
const educationPatternEl = document.querySelector(".js--pattern-education");
const formResume = document.getElementById("profile-experience-form");
if (phonePatternEl) {
  const phonePattern = `
    <div class='phone'>
        ${phonePatternEl.innerHTML}
    </div>
`;


  const phoneCode = '+380';

  function phoneSetAttr() {
    const phones = document.querySelectorAll(".phone");
    phones.forEach((phone, index) => {
      if (phone.offsetParent !== null) {
        const radioInputs = phone.querySelectorAll(".js--radio_group_phone_type input[type='radio']");
        const errorsElemenents = phone.querySelectorAll(".error");
        radioInputs.forEach((radioInput) => {
          radioInput.setAttribute("name", `UserSettings[phones][is_mobile][${index}]`);
        });
        errorsElemenents.forEach((errorsElemenent) => {
          errorsElemenent.setAttribute("id", `UserSettings[phones][phone][${index}]`);
          errorsElemenent.setAttribute("data-name", `UserSettings_phones__phone__${index}`);
        });

        const textInput = phone.querySelector(".js--phoneInput");
        if (textInput) {
          textInput.setAttribute("name", `UserSettings[phones][phone][${index}]`);
          textInput.setAttribute("data-validation", 'required|phone');
          textInput.classList.add('validation');
          new MaskInput(textInput, { mask: '+380 ## ### ## ##'});

          textInput.addEventListener('focus', () => {
            if (!textInput.value.startsWith(phoneCode)) {
              textInput.value = phoneCode + textInput.value;
            }
          });

          textInput.addEventListener('blur', () => {
            if (textInput.value === phoneCode) {
              textInput.value = '';
            }
          });
        }



      }
    });
    if (window.initializeForms) {
      window.initializeForms();
    }
  }

  document.querySelector('.profile_info_contacts').addEventListener("click", (event) => {
    if (event.target.closest('.js--contact_phone_del')) {
      const phone = event.target.closest(".phone");
      if (phone) {
        phone.remove();
        phoneSetAttr();
      }
    }
  });

  document.querySelector('.js--contact_phone_add').addEventListener("click", (event) => {
    const lastPhone = document.querySelector('.phone:last-of-type');
    if (lastPhone) {
      lastPhone.insertAdjacentHTML("afterend", phonePattern);
    } else {
      const phonesWrap = document.querySelector(".profile_info_contacts .profile_info_title");
      if (phonesWrap) {
        phonesWrap.insertAdjacentHTML("afterend", phonePattern);
      }
    }
    phoneSetAttr();
  });

  phoneSetAttr();
}

if (jobPatternEl) {
  const jobPattern = `
    <div class='job'>
        ${jobPatternEl.innerHTML}
    </div>
`;

  document.querySelector('.js--job_add').addEventListener("click", (event) => {
    const lastJob = document.querySelector('.inner-job:last-of-type');
    const jobPatternHTML = jobPattern.replace(/js_replace_name/g, `new${Math.floor(Math.random() * 999999)}`);
    if (lastJob) {
      lastJob.insertAdjacentHTML("afterend", jobPatternHTML);
      setTimeout( () => {
        window.customForms[formResume.getAttribute('id')].mutators.registerField();
      }, 1000);
      initializeChoices();
    } else {
      const jobsWrap = document.querySelector(".js--job_wrapper .profile_info_title");
      if (jobsWrap) {
        jobsWrap.insertAdjacentHTML("afterend", jobPatternHTML);
        setTimeout( () => {
          window.customForms[formResume.getAttribute('id')].mutators.registerField();
        }, 1000);
        initializeChoices();
      }
    }
  });

  document.querySelector('.js--job_wrapper').addEventListener("click", (event) => {
    if (event.target.closest('.js--inner_remove')) {
      const job = event.target.closest(".job");
      if (job) {
        job.remove();
        setTimeout( () => {
          window.customForms[formResume.getAttribute('id')].mutators.registerField();
        }, 1000);
      }
    }
  });

}

if (educationPatternEl) {
  const educationPattern = `
    <div class='education'>
        ${educationPatternEl.innerHTML}
    </div>
`;

  document.querySelector('.js--education_add').addEventListener("click", (event) => {
    const lastEducation = document.querySelector('.inner-education:last-of-type');
    const educationPatternHTML = educationPattern.replace(/js_replace_name/g, `new${Math.floor(Math.random() * 999999)}`);
    if (lastEducation) {
      lastEducation.insertAdjacentHTML("afterend", educationPatternHTML);
      setTimeout( () => {
        window.customForms[formResume.getAttribute('id')].mutators.registerField();
      }, 1000);
      initializeChoices();
    } else {
      const educationWrap = document.querySelector(".js--education_wrapper .profile_info_title");
      if (educationWrap) {
        educationWrap.insertAdjacentHTML("afterend", educationPatternHTML);
        setTimeout( () => {
          window.customForms[formResume.getAttribute('id')].mutators.registerField();
        }, 1000);
        initializeChoices();
      }
    }
  });

  document.querySelector('.js--education_wrapper').addEventListener("click", (event) => {
    if (event.target.closest('.js--education_remove')) {
      const education = event.target.closest(".education");
      if (education) {
        education.remove();
        setTimeout( () => {
          window.customForms[formResume.getAttribute('id')].mutators.registerField();
        }, 1000);
      }
    }
  });

}




const loadAvatarBtn = document.getElementById('userLoadAvatarInput');
if (loadAvatarBtn) {

  document.addEventListener('DOMContentLoaded', function () {
    const imageCropFunctions = {};
    const minImageWidth = 140;
    const minImageHeight = 140;
    let cropper;
    const formDataAvatar = new FormData();

    imageCropFunctions.readUrl = function (input) {
      if (input.files && input.files[0]) {
        if (input.files[0].type.match('image.*')) {
          const reader = new FileReader();

          reader.onload = function (e) {
            const imageFile = new Image();
            imageFile.src = e.target.result;

            imageFile.onload = function () {
              if (imageFile.width < minImageWidth || imageFile.height < minImageHeight) {
                alert(`Image size is too small (${minImageWidth}x${minImageHeight}px). Minimum image size is ${minImageWidth}x${minImageHeight}px.`);
                return;
              }

              const cropperElement = document.getElementById('cropper');
              cropperElement.src = imageFile.src;
              cropperElement.style.display = 'block';

              if (cropper) {
                cropper.destroy();
              }

              const modalElement = document.getElementById('cropperModal');
              const bootstrapModal = new Modal(modalElement);
              let cropBoxData;
              let canvasData;

              modalElement.addEventListener('shown.bs.modal', function () {
                cropper = new Cropper(cropperElement, {
                  autoCropArea: 0.5,
                  viewMode: 1,
                  movable: true,
                  scalable: true,
                  zoomable: true,
                  zoomOnTouch: true,
                  zoomOnWheel: true,
                  cropBoxResizable: true,
                  ready: function () {
                    //Should set crop box data first here
                    cropper.setCropBoxData(cropBoxData).setCanvasData(canvasData);
                  }
                });
              });
              modalElement.addEventListener('hidden.bs.modal', function () {
                cropBoxData = cropper.getCropBoxData();
                canvasData = cropper.getCanvasData();
              });
              bootstrapModal.show();

            };
          };

          reader.readAsDataURL(input.files[0]);
        }
      }
    };

    document.getElementById('btn-crop').addEventListener('click', function () {
      if (document.getElementById('userLoadAvatarInput').value) {
        const croppedImage = cropper.getCroppedCanvas().toDataURL();
        formDataAvatar.append('croppedImage', croppedImage);
        _addCsrfToken(formDataAvatar);
      }

      fetch('/profile/ajax/profile-image', {
        method: 'POST',
        body: formDataAvatar,
      })
          .then(response => response.json())
          .then(data => {
            if (!data || !data.result.id) {
              notyf.error(data.message ?? 'Ошибка загрузки. Попробуйте еще раз');
              return;
            }

            if (data.error) {
              notyf.error(data.message ?? 'no data.message found');
            } else {
              const profileForm = document.getElementById('profile-edit-form');
              const imageIdInput = profileForm.querySelector('input[name*=image_id]');
              const imgWrap = profileForm.querySelector('.profile_photo');

              imageIdInput.value = data.result.id;
              if (!imgWrap.querySelector('img')) {
                imgWrap.innerHTML = '<img />';
              }
              imgWrap.querySelector('img').src = `${window.user_frontend_url}/image/${data.result.id}?width=140&height=140`;

              const modalElement = document.getElementById('cropperModal');
              const bootstrapModal = Modal.getInstance(modalElement);
              bootstrapModal.hide();
            }
          })
          .catch(error => {
            console.error('Error:', error);
          });
    });

    document.getElementById('userLoadAvatarInput').addEventListener('change', function (event) {
      imageCropFunctions.readUrl(this);
      formDataAvatar.append('files', event.target.files[0]);
    });
  });


}

document.addEventListener('click', function(event) {
  if (event.target.classList.contains('js--remove-avatar')) {
    event.preventDefault();
    const btn = event.target;
    const url = btn.dataset.url;
    const formData = new FormData();
    _addCsrfToken(formData);

    fetch(url, {
      method: 'POST',
      body: formData,
    })
        .then(response => response.json())
        .then(res => {
          if (res.status === 'ok') {
            const profileForm = document.getElementById('profile-edit-form');
            const img = profileForm.querySelector('.profile_photo img');
            if (img) {
              console.log(res.avatar);
              img.src = res.avatar;
            }
            btn.style.display = 'none';
            notyf.success(res.message);
          } else {
            notyf.error(res.message);
          }
        })
        .catch(error => console.error('Error:', error));

    return false;
  }
});

document.addEventListener('click', function(event) {
  if (event.target.closest('.js--delete_resume_file')) {
    const item = event.target.closest('.profile_info__files_item');
    const id = item ? item.dataset.id : null;
    const params = new URLSearchParams();
    params.append('_csrf', document.querySelector('meta[name="csrf-token"]').getAttribute('content'));
    params.append('id', id);

    if (id) {
      fetch('/profile/ajax/delete-resume-file', {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: params
      })
          .then(response => response.json())
          .then(res => {
            if (res.status === 'ok') {
              item.remove();
            }
          })
          .catch(error => {
            console.error('Ошибка:', error);
          });
    }

    event.preventDefault();
  }
});

function toggleChoicesBasedOnCheckbox(checkbox) {
  let parentWrapJob = checkbox.closest('.job');
  let parentWrapEdu = checkbox.closest('.education');
  if (parentWrapJob) {
    let EndMonth = parentWrapJob.querySelector('.js--choices[name*=end_month]');
    let EndYear = parentWrapJob.querySelector('.js--choices[name*=end_year]');
    const choiceInstanceEndMonth = window.choicesSelects.find(choice => choice.passedElement.element === EndMonth);
    const choiceInstanceEndYear = window.choicesSelects.find(choice => choice.passedElement.element === EndYear);

    if (choiceInstanceEndMonth && choiceInstanceEndYear) {
      if (checkbox.checked) {
        choiceInstanceEndMonth.disable();
        choiceInstanceEndYear.disable();
      } else {
        choiceInstanceEndMonth.enable();
        choiceInstanceEndYear.enable();
      }
    }
  }
  if (parentWrapEdu) {
    let EndMonth = parentWrapEdu.querySelector('.js--choices[name*=end_month]');
    let EndYear = parentWrapEdu.querySelector('.js--choices[name*=end_year]');
    const choiceInstanceEndMonth = window.choicesSelects.find(choice => choice.passedElement.element === EndMonth);
    const choiceInstanceEndYear = window.choicesSelects.find(choice => choice.passedElement.element === EndYear);

    if (choiceInstanceEndMonth && choiceInstanceEndYear) {
      if (checkbox.checked) {
        choiceInstanceEndMonth.disable();
        choiceInstanceEndYear.disable();
      } else {
        choiceInstanceEndMonth.enable();
        choiceInstanceEndYear.enable();
      }
    }
  }
}

document.addEventListener('change', function(event) {
  if (event.target.matches('.js--job_wrapper input[name*=no_end]')) {
    toggleChoicesBasedOnCheckbox(event.target);
  }
  if (event.target.matches('.js--education_wrapper input[name*=no_end]')) {
    toggleChoicesBasedOnCheckbox(event.target);
  }
});

function initFilePond() {

  FilePond.registerPlugin(
      FilePondPluginFileEncode,
  );
  const loadedFileArray = [];
  const filesToLoad = [];

  const currentLanguage = document.body.classList.contains('ru') ? 'ru' : 'ua';
  const label = {};
  switch (currentLanguage) {
    case 'ru':
      FilePond.setOptions(ru);
      label.title = 'Загрузить файл';
      label.text = 'Выберите файл или перетащите его сюда';
      label.button = 'Выбрать файл';
      break;
    case 'ua':
      FilePond.setOptions(ua);
      label.title = 'Завантажити файл';
      label.text = 'Оберіть файл або перетягніть його сюди';
      label.button = 'Обрати файл';
      break;
    default:
  }
  FilePond.setOptions({
    credits: false,
    allowRevert: false,
    labelIdle: '<div class="filepond__label_wrap"><div><svg width="46" height="38" viewBox="0 0 46 38" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M31 27L23 19L15 27" stroke="black" stroke-opacity="0.4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '<path d="M23 19V37" stroke="#C5E6B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '<path d="M39.7828 31.78C41.7335 30.7165 43.2745 29.0337 44.1626 26.9972C45.0507 24.9607 45.2353 22.6864 44.6873 20.5334C44.1392 18.3803 42.8898 16.471 41.1362 15.1069C39.3826 13.7427 37.2246 13.0014 35.0028 13H32.4828C31.8775 10.6585 30.7492 8.48464 29.1827 6.64195C27.6163 4.79927 25.6525 3.33567 23.439 2.36118C21.2256 1.3867 18.8199 0.926686 16.4031 1.01573C13.9862 1.10478 11.621 1.74057 9.4852 2.8753C7.34942 4.01003 5.49867 5.61417 4.07209 7.56713C2.64551 9.52009 1.68023 11.771 1.24881 14.1508C0.81739 16.5305 0.931061 18.977 1.58128 21.3065C2.23149 23.636 3.40133 25.7877 5.00285 27.6" stroke="#C5E6B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '<path d="M31 27L23 19L15 27" stroke="#C5E6B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>\n' +
        '</svg>\n</div>' +
        `<div class="filepond__label_title">${label.title}</div>` +
        `<div class="filepond__label_text">${label.text}</div>` +
        `<span class="filepond--label-action filepond__label_button button button--outlined">${label.button}</span></div>`
  });
  FilePond.create(
      document.querySelector('.filepond'),
      {
        server: {
          process: (fieldName, file, metadata, load, error, progress, abort) => {
            const formData = new FormData();
            if (file.size > 2000000) {
              error('oh no');
              return {
                abort: () => {
                  abort();
                },
              };
            }
            formData.append(fieldName, file, file.name);
            _addCsrfToken(formData);
            const request = new XMLHttpRequest();
            const url = formResume.getAttribute('data-files-action');
            request.open('POST', url);
            request.upload.onprogress = (e) => {
              progress(e.lengthComputable, e.loaded, e.total);
            };
            request.onload = function () {
              const parsedResponse = JSON.parse(request.response);
              if (request.status >= 200 && request.status < 300) {
                load(request.responseText);
                console.log(parsedResponse);
                // const fileId = parsedResponse.file[0].id;
                // filesToLoad.push(fileId);
                if (parsedResponse.data) {
                  const filesWrap = document.querySelector('.js--profile_files');
                  console.log(filesWrap);
                  console.log(parsedResponse.data);
                  filesWrap.insertAdjacentHTML('beforeend', parsedResponse.data)
                }
              } else {
                Object.keys(parsedResponse.errors).forEach((nameFiled) => {
                  if (nameFiled !== 'default') {
                  }
                });
                error('oh no');
              }
            };
            request.send(formData);
            return {
              abort: () => {
                request.abort();
                abort();
              },
            };
          },
        },
        files: loadedFileArray,
      },
  );
}
initFilePond();


function updateFieldSet() {
  const fieldSet = document.querySelectorAll('.js--card');
  fieldSet.forEach(parent => {
    const parentTitle = parent.querySelector('.profile_info_title');
    if (parentTitle && !parentTitle.classList.contains('has-invalid') && parent.querySelector('.invalid')) {
      parentTitle.classList.add('has-invalid');
    } else if (parentTitle && parentTitle.classList.contains('has-invalid') && !parent.querySelector('.invalid')) {
      parentTitle.classList.remove('has-invalid');
    }
  });
}

const observer = new MutationObserver((mutationsList) => {
  let shouldUpdate = false;

  for (const mutation of mutationsList) {
    if (
        mutation.type === 'childList' ||
        (mutation.type === 'attributes' && mutation.target.classList.contains('invalid'))
    ) {
      shouldUpdate = true;
      break;
    }
  }

  if (shouldUpdate) {
    observer.disconnect();
    updateFieldSet();
    observer.observe(targetNode, config);
  }
});

const targetNode = document.body;
const config = {
  childList: true,
  subtree: true,
  attributes: true
};

observer.observe(targetNode, config);

updateFieldSet();

document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.js--job_wrapper input[name*=no_end]').forEach(toggleChoicesBasedOnCheckbox);
  document.querySelectorAll('.js--education_wrapper input[name*=no_end]').forEach(toggleChoicesBasedOnCheckbox);
});
